import { FormTemplateQuestionFormInputs } from "../components/FormTemplateQuestionForm";
import buildConditionObject from "./buildConditionObject";
import buildTypeObject from "./buildTypeObject";

export default function buildFormTemplateQuestionPayload(
    data: FormTemplateQuestionFormInputs,
    existingIds?: { typeId?: string; conditionId?: string },
) {
    const {
        type,
        multiline,
        options,
        condition,
        conditionSelectedQuestion,
        conditionSelectedQuestionOption,
        conditionOrConditions,
        ...rest
    } = data;

    return {
        ...rest,
        type: buildTypeObject(data.type, data, existingIds?.typeId),
        condition: buildConditionObject(data.condition, data, existingIds?.conditionId),
    };
}
